import { connect } from 'react-redux';
import * as React from 'react';
import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import './CreateHook.css';
import CloseIcon from '@mui/icons-material/Close';
import { createHook, editHook, fetchHookDetails } from '../../store/app/apis';
import Toast from 'light-toast';
import Switch from '@mui/material/Switch';

function CreateHook({ hookList, fetchHookDetails, editHook, createHook, ...props }) {
  const [anchorEl, setAnchorEl] = useState(props.anchorEl);
  const [checked, setChecked] = useState(false);
  const [switchOn, setSwitchOn] = useState(false);
  const [chatswitchOn, setChatSwitchOn] = useState(false);
  const open = Boolean(anchorEl);
  const [state, setState] = useState({
    name: '',
    telegram: {
      token: '',
      chat: '',
    },
    mail: {
      user: '',
      pass: '',
      host: '',
      email: '',
    },
    gspace: {
      url: '',
    },
  });
  const handleChatSpaceUrlChange = (e) => {
    setState((prev) => ({
      ...prev,
      gspace: { ...prev.gspace, url: e.target.value },
    }));
  };
  const cancelPop = () => {
    setAnchorEl(null);
    props.onClose();
  };

  const handleNameChange = (e) => {
    setState((prev) => ({
      ...prev,
      name: e.target.value,
    }));
  };

  const handleTelegramTokenChange = (e) => {
    setState((prev) => ({
      ...prev,
      telegram: { ...prev.telegram, token: e.target.value },
    }));
  };
  const handleMailUserChange = (e) => {
    setState((prev) => ({
      ...prev,
      mail: { ...prev.mail, user: e.target.value },
    }));
  };
  const handleMailPasswordChange = (e) => {
    setState((prev) => ({
      ...prev,
      mail: { ...prev.mail, pass: e.target.value },
    }));
  };
  const handleMailHostChange = (e) => {
    setState((prev) => ({
      ...prev,
      mail: { ...prev.mail, host: e.target.value },
    }));
  };
  const handleMailEmailChange = (e) => {
    setState((prev) => ({
      ...prev,
      mail: { ...prev.mail, email: e.target.value },
    }));
  };
  const handleTelegramChatChange = (e) => {
    setState((prev) => ({
      ...prev,
      telegram: { ...prev.telegram, chat: e.target.value },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (state?.name === '') {
      Toast.fail('Please enter hook name!');
    } else if (
      (state?.telegram?.chat === '' || state?.telegram?.token === '') &&
      state?.gspace?.url === '' &&
      (state?.mail?.email === '' || state?.mail?.host === '' || state?.mail?.pass === '' || state?.mail?.user === '')
    ) {
      Toast.fail('Please enter complete details of any one type!');
    } else {
      if (props.id) {
        editHook({
          id: props.id,
          ...state,
        });
        cancelPop();
        return;
      }
      createHook(state).then((res) => {
        setState((prev) => ({
          ...prev,
          name: '',
          telegram: {
            token: '',
            chat: '',
          },
          mail: {
            user: '',
            pass: '',
            host: '',
            email: '',
          },
          gspace: {
            url: '',
          },
        }));
        cancelPop();
      });
    }
  };
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleSwitchChange = (event) => {
    setSwitchOn(event.target.checked);
  };
  const handleChatSwitchChange = (event) => {
    setChatSwitchOn(event.target.checked);
  };
  useEffect(() => {
    if (!props.id) return;
    if (hookList?.length !== 0) setState(hookList?.find((hook) => hook.id === props.id));
    else {
      fetchHookDetails(props.id).then((res) => {
        setState(res);
      });
    }
  }, [props.id]);

  useEffect(() => {
    setAnchorEl(props.anchorEl);
  }, [props.anchorEl]);

  return (
    <>
      <Dialog id="create-popover" open={open}>
        <Box
          sx={{
            padding: '20px',
          }}
        >
          <div className="formTitle">
            <h3>Hook Form </h3>
            <CloseIcon onClick={cancelPop} sx={{ cursor: 'pointer' }} />
          </div>
          <form className="forminfo">
            <div className="telegramInfo">
              <div className="forminput" style={{ paddingTop: 15 }}>
                <label>Enter Title</label>
                <span className="redstar">*</span>
                <TextField
                  id="outlined-basic"
                  onChange={handleNameChange}
                  placeholder="Title"
                  value={state?.name}
                  variant="outlined"
                />
              </div>
              <div className="teleinfo">
                <label>Telegram Information</label>
                <Switch switchOn={switchOn} onChange={handleSwitchChange} inputProps={{ 'aria-label': 'controlled' }} />
              </div>
              {switchOn && (
                <div className="forminput" style={{ paddingTop: 10 }}>
                  <label>Enter Telegram Token</label>
                  <span className="redstar">*</span>
                  <TextField
                    id="outlined-basic"
                    onChange={handleTelegramTokenChange}
                    placeholder="Token"
                    value={state?.telegram?.token}
                    variant="outlined"
                  />
                </div>
              )}
              {switchOn && (
                <div className="forminput">
                  <label>Enter Telegram Chat ID</label>
                  <span className="redstar">*</span>
                  <TextField
                    id="outlined-basic"
                    onChange={handleTelegramChatChange}
                    placeholder="Chat"
                    value={state?.telegram?.chat}
                    variant="outlined"
                  />
                </div>
              )}
            </div>
            <div className="teleinfo">
              <label>Email Information</label>
              <Switch checked={checked} onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} />
            </div>
            {checked && (
              <div className="emailInfo">
                <div className="forminput">
                  <label>Enter Email</label>
                  <span className="redstar">*</span>
                  <TextField
                    id="outlined-basic"
                    placeholder="Email"
                    onChange={handleMailEmailChange}
                    value={state?.mail?.email}
                    variant="outlined"
                  />
                </div>
                <div className="forminput">
                  <label>Enter User</label>
                  <span className="redstar">*</span>
                  <TextField
                    id="outlined-basic"
                    placeholder="User"
                    onChange={handleMailUserChange}
                    value={state?.mail?.user}
                    variant="outlined"
                  />
                </div>
                <div className="forminput">
                  <label>Enter Password</label>
                  <span className="redstar">*</span>
                  <TextField
                    id="outlined-basic"
                    placeholder="Password"
                    onChange={handleMailPasswordChange}
                    value={state?.mail?.pass}
                    variant="outlined"
                  />
                </div>
                <div className="forminput">
                  <label>Enter Host</label>
                  <span className="redstar">*</span>
                  <TextField
                    id="outlined-basic"
                    placeholder="Host"
                    onChange={handleMailHostChange}
                    value={state?.mail?.host}
                    variant="outlined"
                  />
                </div>
              </div>
            )}
            <div className="teleinfo">
              <label>Google Chat Space Details</label>
              <Switch
                chatswitchOn={chatswitchOn}
                onChange={handleChatSwitchChange}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            </div>
            {chatswitchOn && (
              <div className="emailInfo">
                <div className="forminput">
                  <label>Enter Url</label>
                  <span className="redstar">*</span>
                  <TextField
                    id="outlined-basic"
                    placeholder="Url"
                    onChange={handleChatSpaceUrlChange}
                    value={state?.gspace?.url}
                    variant="outlined"
                  />
                </div>
              </div>
            )}
            <div className="buttonscancel">
              <button onClick={cancelPop}>Cancel</button>
              <button onClick={handleSubmit}>{props.id ? 'Edit' : 'Add'}</button>
            </div>
          </form>
        </Box>
      </Dialog>
    </>
  );
}

const mapStateToProps = (state) => ({
  hookList: state.app.hookList,
});

const mapDispatchToProps = { editHook, createHook, fetchHookDetails };

export default connect(mapStateToProps, mapDispatchToProps)(CreateHook);
